import React from 'react';

function TourPackageDetails({ tour }) {
  const destinationName = tour.destination?.name || 'Unknown';
  const countryName = tour.destination?.country?.name || 'Unknown';
  const packageTypeName = tour.package_type?.name || 'Unknown';
  const categoryName = tour.category?.name || 'Uncategorized';
  const themedHolidayName = tour.themed_holiday?.name || 'None';

  const handleBookingSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const bookingData = {
      name: formData.get('name'),
      email: formData.get('email'),
      message: formData.get('message'),
      tour: {
        id: tour.id,
        name: tour.name,
        destination: `${destinationName}, ${countryName}`,
        basePrice: tour.base_price,
        discountPrice: tour.discount_price,
        days: tour.days,
        nights: tour.nights,
      },
    };
    // Redirect to checkout page with booking data
    const queryParams = new URLSearchParams(bookingData).toString();
    window.location.href = `/checkout?${queryParams}`;
  };

  return (
    <section className="destination-details-section section-padding fix">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-8">
            <div className="destination-details-wrapper">
              <div className="destionation-blog-item">
                <div className="thumb">
                  <img
                    src={tour.images?.[0] || 'assets/img/destinations/20.jpg'}
                    alt={tour.name || 'Tour Image'}
                  />
                </div>
                <div className="content">
                  <h2>
                    Explore the Beautiful Charm <br /> of {destinationName}
                  </h2>
                  <p>{tour.description || 'No description available'}</p>
                  {tour.itineraries?.length > 0 && (
                    <div className="mt-3">
                      <h4>Itinerary</h4>
                      {tour.itineraries.map((itinerary, index) => (
                        <div key={index} className="mb-2">
                          <h5>Day {itinerary.day_number}: {itinerary.title || 'No Title'}</h5>
                          <p>{itinerary.description || 'No details available'}</p>
                        </div>
                      ))}
                    </div>
                  )}
                  <p className="mt-3">
                    Duration: {tour.days || 0} days / {tour.nights || 0} nights | Base Price: $
                    {tour.base_price || '0.00'} |{' '}
                    {tour.discount_price && `Discount Price: $${tour.discount_price}`} | Rating: {tour.average_rating || 'N/A'} (
                    {tour.review_count || 0} reviews)
                  </p>
                </div>
              </div>
              <div className="destination-blog-item2">
                <div className="row g-4">
                  {tour.images?.slice(1, 3).map((img, index) => (
                    <div className="col-md-6" key={index}>
                      <div className="thumb">
                        <img
                          src={img || `assets/img/destinations/${21 + index}.jpg`}
                          alt={`${tour.name || 'Tour'} ${index + 1}`}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <p>
                  Package Type: {packageTypeName}<br />
                  Category: {categoryName}<br />
                  Themed Holiday: {themedHolidayName}<br />
                  Included Services: {tour.included_services?.join(', ') || 'None'}<br />
                  Excluded Services: {tour.excluded_services?.join(', ') || 'None'}<br />
                  Special Notes: {tour.special_notes?.join(', ') || 'None'}<br />
                  Availability: {tour.availability_status || 'N/A'}
                </p>
              </div>
              <div className="destination-map-area">
                <h3>View in Map</h3>
                <div className="google-map">
                  <iframe
                    src={`https://www.google.com/maps?q=${encodeURIComponent(
                      `${destinationName}, ${countryName}`
                    )}&output=embed`}
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    title="Tour Location Map"
                  ></iframe>
                </div>
              </div>
              <div className="destination-reviews-item">
                <h3>Clients Reviews</h3>
                {tour.reviews?.length > 0 ? (
                  tour.reviews.map((review, index) => (
                    <div className="comment-item" key={index}>
                      <div className="thumb">
                        <img src="assets/img/activities/11.jpg" alt="img" />
                      </div>
                      <div className="content">
                        <div className="head">
                          <div className="left">
                            <div className="star">
                              {[...Array(5)].map((_, i) => (
                                <i
                                  key={i}
                                  className={`fa-solid fa-star${i < Math.round(review.rating || 0) ? '' : '-o'}`}
                                ></i>
                              ))}
                            </div>
                            <h4>{review.user_name || 'Anonymous'}</h4>
                          </div>
                          <div className="right">
                            <h6>
                              <img src="assets/img/icon/36.svg" alt="" /> Reply
                            </h6>
                          </div>
                        </div>
                        <p>{review.comment || 'No comment provided'}</p>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No reviews yet.</p>
                )}
              </div>
              <div className="destination-form-item">
                <h3>Add Your Reviews</h3>
                <div className="form-content">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="star-item">
                        <h5>Services</h5>
                        <div className="star-rating" id="service-rating">
                          <i className="fa-solid fa-star-sharp" data-index="1"></i>
                          <i className="fa-solid fa-star-sharp" data-index="2"></i>
                          <i className="fa-solid fa-star-sharp" data-index="3"></i>
                          <i className="fa-solid fa-star-sharp" data-index="4"></i>
                          <i className="fa-solid fa-star-sharp" data-index="5"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="star-item">
                        <h5>Hotel</h5>
                        <div className="star-rating" id="hotels-rating">
                          <i className="fa-solid fa-star-sharp" data-index="1"></i>
                          <i className="fa-solid fa-star-sharp" data-index="2"></i>
                          <i className="fa-solid fa-star-sharp" data-index="3"></i>
                          <i className="fa-solid fa-star-sharp" data-index="4"></i>
                          <i className="fa-solid fa-star-sharp" data-index="5"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="star-item">
                        <h5>Places</h5>
                        <div className="star-rating" id="place-rating">
                          <i className="fa-solid fa-star-sharp" data-index="1"></i>
                          <i className="fa-solid fa-star-sharp" data-index="2"></i>
                          <i className="fa-solid fa-star-sharp" data-index="3"></i>
                          <i className="fa-solid fa-star-sharp" data-index="4"></i>
                          <i className="fa-solid fa-star-sharp" data-index="5"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="star-item">
                        <h5>Safety</h5>
                        <div className="star-rating" id="safety-rating">
                          <i className="fa-solid fa-star-sharp" data-index="1"></i>
                          <i className="fa-solid fa-star-sharp" data-index="2"></i>
                          <i className="fa-solid fa-star-sharp" data-index="3"></i>
                          <i className="fa-solid fa-star-sharp" data-index="4"></i>
                          <i className="fa-solid fa-star-sharp" data-index="5"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="star-item">
                        <h5>Foods</h5>
                        <div className="star-rating" id="foods-rating">
                          <i className="fa-solid fa-star-sharp" data-index="1"></i>
                          <i className="fa-solid fa-star-sharp" data-index="2"></i>
                          <i className="fa-solid fa-star-sharp" data-index="3"></i>
                          <i className="fa-solid fa-star-sharp" data-index="4"></i>
                          <i className="fa-solid fa-star-sharp" data-index="5"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="star-item">
                        <h5>Guides</h5>
                        <div className="star-rating" id="guides-rating">
                          <i className="fa-solid fa-star-sharp" data-index="1"></i>
                          <i className="fa-solid fa-star-sharp" data-index="2"></i>
                          <i className="fa-solid fa-star-sharp" data-index="3"></i>
                          <i className="fa-solid fa-star-sharp" data-index="4"></i>
                          <i className="fa-solid fa-star-sharp" data-index="5"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <form action="#" id="contact-form" method="post">
                    <div className="row g-4">
                      <div className="col-lg-6">
                        <div className="form-clt">
                          <input type="text" name="name" id="name" placeholder="Your Name" />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-clt">
                          <input type="text" name="phone" id="phone" placeholder="Your Phone" />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-clt">
                          <input type="email" name="email" id="email" placeholder="Your Email" />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-clt">
                          <textarea name="message" id="message" placeholder="Write Message"></textarea>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <button type="submit" className="theme-btn ">
                          Post Comment
                          <img src="assets/img/icon/white-arrow.svg" alt="" />
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="main-sidebar-widget">
              <div className="single-sidebar-widget">
                <h3>Search Here</h3>
                <div className="search-widget">
                  <form action="#">
                    <input type="text" placeholder="Search here" />
                    <button type="submit">
                      <img src="assets/img/icon/search_icon.svg" alt="" />
                    </button>
                  </form>
                </div>
              </div>
              <div className="single-sidebar-widget">
                <h3>Contact for Booking</h3>
                <div className="form-widget">
                  <form onSubmit={handleBookingSubmit}>
                    <input type="text" name="name" placeholder="Your Name" required />
                    <input type="email" name="email" placeholder="Your Email" required />
                    <textarea name="message" placeholder="Type Comment or Request Here" required></textarea>
                    <button type="submit" className="theme-btn">
                      Send Now
                      <img src="assets/img/icon/white-arrow.svg" alt="" />
                    </button>
                  </form>
                </div>
              </div>
              <div className="single-sidebar-widget">
                <h3>Recent Tours</h3>
                <div className="recent-widget-item">
                  <div className="thumb">
                    <img src="assets/img/destinations/23.jpg" alt="img" />
                  </div>
                  <div className="content">
                    <div className="star">
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                    </div>
                    <h6>
                      <a href="destination-details.html">Enrich Your Mind Envision Your Future Education for Success</a>
                    </h6>
                  </div>
                </div>
                <div className="recent-widget-item">
                  <div className="thumb">
                    <img src="assets/img/destinations/24.jpg" alt="img" />
                  </div>
                  <div className="content">
                    <div className="star">
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                    </div>
                    <h6>
                      <a href="destination-details.html">Quality Assuranc Requirements Web Dev Risk Manage</a>
                    </h6>
                  </div>
                </div>
                <div className="recent-widget-item mb-0">
                  <div className="thumb">
                    <img src="assets/img/destinations/25.jpg" alt="img" />
                  </div>
                  <div className="content">
                    <div className="star">
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                      <i className="fa-solid fa-star"></i>
                    </div>
                    <h6>
                      <a href="destination-details.html">Meet Skeleton Svelte Taile Sindey For Reactive UIs</a>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TourPackageDetails;